import { isOfType, unreachable } from '../../../../ts-utils';
import { EDIT_COMMENT, CANCEL_CREATING_COMMENT, CANCEL_EDITING_COMMENT, CREATE_COMMENT_REQUEST, UPDATE_COMMENT_REQUEST, RETRY_CREATE_COMMENT_REQUEST, CREATE_COMMENT_FAILURE, UPDATE_COMMENT_FAILURE, DELETE_COMMENT_SUCCESS, CREATE_COMMENT_SUCCESS, UPDATE_COMMENT_SUCCESS, EDIT_COMMENT_CREATE_ERROR, DELETE_COMMENT_REQUEST, DELETE_COMMENT_FAILURE, } from './top-level-comments-crud-actions';
export const topLevelCommentsRatingsReducer = (state, action) => {
    if (!state.configs.withRatings) {
        return state.ratings;
    }
    switch (action.type) {
        case CANCEL_EDITING_COMMENT:
        case CANCEL_CREATING_COMMENT: {
            return { ...state.ratings, inputRating: state.ratings.currentRating.value };
        }
        case EDIT_COMMENT: {
            const currentState = state.commentsById[action.payload.commentId];
            if (!isOfType(['COMMENT_READY', 'COMMENT_UPDATE_ERROR'], currentState) ||
                (!action.meta.commentByCurrentOwner && !state.ratings.currentRating.value !== undefined)) {
                return state.ratings;
            }
            return {
                ...state.ratings,
                inputRating: currentState.type === 'COMMENT_UPDATE_ERROR'
                    ? currentState.pendingRatingAction?.type === 'ADD'
                        ? currentState.pendingRatingAction.value
                        : undefined
                    : state.ratings.currentRating.value,
            };
        }
        case CREATE_COMMENT_REQUEST:
        case UPDATE_COMMENT_REQUEST:
        case RETRY_CREATE_COMMENT_REQUEST: {
            const rating = action.payload.rating?.type === 'ADD' ? action.payload.rating.value : undefined;
            return {
                ...state.ratings,
                currentRating: { ...state.ratings.currentRating, type: 'PENDING', pendingValue: rating },
                inputRating: rating,
            };
        }
        case CREATE_COMMENT_FAILURE:
        case UPDATE_COMMENT_FAILURE: {
            return {
                ...state.ratings,
                currentRating: {
                    type: 'IDLE',
                    value: state.ratings.currentRating.value,
                },
                inputRating: state.ratings.currentRating.value,
            };
        }
        case DELETE_COMMENT_SUCCESS: {
            const { publishedCommentCount = 0, currentRating, breakdown, total } = state.ratings;
            if (publishedCommentCount === 0) {
                return state.ratings;
            }
            if (publishedCommentCount - 1 === 0 && currentRating.value) {
                return {
                    ...state.ratings,
                    total: total - 1,
                    breakdown: {
                        ...breakdown,
                        [currentRating.value]: breakdown[currentRating.value] - 1,
                    },
                    currentRating: {
                        ...currentRating,
                        value: undefined,
                    },
                    publishedCommentCount: 0,
                    inputRating: undefined,
                };
            }
            return { ...state.ratings, publishedCommentCount: publishedCommentCount - 1 };
        }
        case CREATE_COMMENT_SUCCESS:
        case UPDATE_COMMENT_SUCCESS: {
            const { rating } = action.payload;
            const { publishedCommentCount, total } = state.ratings;
            const ADJUST_TOTAL = { ADD: 1, REMOVE: -1, UPDATE: 0, NONE: 0 };
            const rateAction = resolveRateAction(state.ratings, rating);
            const breakdown = resolveNextBreakdown(state.ratings, rateAction);
            return {
                ...state.ratings,
                total: total + ADJUST_TOTAL[rateAction.type],
                breakdown,
                currentRating: {
                    type: 'IDLE',
                    value: rating,
                },
                publishedCommentCount: action.type === 'CREATE_COMMENT_SUCCESS'
                    ? (publishedCommentCount ?? 0) + 1
                    : publishedCommentCount,
            };
        }
        case EDIT_COMMENT_CREATE_ERROR: {
            const { localId } = action.payload;
            const currentState = state.commentsById[localId];
            if (currentState.type !== 'COMMENT_CREATE_ERROR') {
                return state.ratings;
            }
            const inputRating = currentState.pendingRatingAction?.type === 'ADD'
                ? currentState.pendingRatingAction.value
                : undefined;
            return {
                ...state.ratings,
                inputRating,
            };
        }
        case DELETE_COMMENT_REQUEST:
        case DELETE_COMMENT_FAILURE:
            return state.ratings;
        default:
            throw unreachable(action);
    }
};
const resolveRateAction = (state, rating) => {
    if (typeof rating === 'undefined' && typeof state.currentRating.value === 'undefined') {
        return { type: 'NONE' };
    }
    if (typeof rating === 'undefined') {
        return { type: 'REMOVE', rating: undefined };
    }
    return state.currentRating.value ? { type: 'UPDATE', rating } : { type: 'ADD', rating };
};
const resolveNextBreakdown = (state, rateAction) => {
    switch (rateAction.type) {
        case 'NONE': {
            return state.breakdown;
        }
        case 'ADD':
            return {
                ...state.breakdown,
                [rateAction.rating]: state.breakdown[rateAction.rating] + 1,
            };
        case 'REMOVE':
            const prevRating = state.currentRating.value;
            if (!prevRating) {
                return state.breakdown;
            }
            return {
                ...state.breakdown,
                [prevRating]: state.breakdown[prevRating] - 1,
            };
        case 'UPDATE': {
            const prevRating = state.currentRating.value;
            if (prevRating === rateAction.rating) {
                return state.breakdown;
            }
            return {
                ...state.breakdown,
                [rateAction.rating]: state.breakdown[rateAction.rating] + 1,
                [prevRating]: state.breakdown[prevRating] - 1,
            };
        }
        default:
            throw unreachable(rateAction);
    }
};
//# sourceMappingURL=top-level-comments-ratings-reducer.js.map